import { useContext, useEffect, useState } from "react";
import { Language } from "../App";

export function usePollStatus(timestamp, duration) {
    const {lang} = useContext(Language)
  const [pollStatus, setPollStatus] = useState("");

  useEffect(() => {
    function convertDurationToSeconds(duration) {
      switch (duration) {
        case "1 Day":
          return 1 * 24 * 60 * 60;
        case "3 Days":
          return 3 * 24 * 60 * 60;
        case "7 Days":
          return 7 * 24 * 60 * 60;
        case "2 Weeks":
          return 14 * 24 * 60 * 60;
        default:
          return 0;
      }
    }

    function formatRemainingTime(seconds) {
      const days = Math.floor(seconds / (24 * 60 * 60));
      const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((seconds % (60 * 60)) / 60);

      if (days > 0) {
        return days === 1
          ? `${days} ${lang.day_left}`
          : `${days} ${lang.days_left}`;
      }

      if (hours > 0) {
        return hours === 1
          ? `${hours} ${lang.hour_left}`
          : `${hours} ${lang.hours_left}`;
      }

      if (minutes > 0) {
        return minutes === 1
          ? `${minutes} ${lang.minute_left}`
          : `${minutes} ${lang.minutes_left}`;
      }

      return lang.poll_closed;
    }

    function getPollStatus() {
      const pollStartTime = parseInt(timestamp, 10);
      if (isNaN(pollStartTime)) return "Invalid timestamp";

      const durationInSeconds = convertDurationToSeconds(duration);
      if (durationInSeconds === 0) return duration;

      const currentTime = Math.floor(Date.now() / 1000);
      const pollEndTime = pollStartTime + durationInSeconds;

      if (currentTime < pollEndTime) {
        const remaining = pollEndTime - currentTime;
        return formatRemainingTime(remaining);
      }

      return lang.poll_closed;
    }

    // Set immediately
    setPollStatus(getPollStatus());

    // Auto update every 1 second
    const interval = setInterval(() => {
      setPollStatus(getPollStatus());
    }, 1000);

    return () => clearInterval(interval);
  }, [timestamp, duration, lang]);

  return pollStatus;
}
